import { render, staticRenderFns } from "./buyInfo.vue?vue&type=template&id=6ba19f41&scoped=true"
import script from "./buyInfo.vue?vue&type=script&lang=js"
export * from "./buyInfo.vue?vue&type=script&lang=js"
import style0 from "./buyInfo.vue?vue&type=style&index=0&id=6ba19f41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba19f41",
  null
  
)

export default component.exports